<div class="content" *ngIf="trainsInfo?.travellersForm">
  <mat-accordion class="formsContainer" multi>
    <mat-expansion-panel class="master-container" *ngFor="let traveller of trainsInfo.travellersForm.controls; let i = index">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "flight.detail-flight.passenger" | translate }} {{ i + 1
          }}{{
          traveller.value.name != "" ||
          traveller.value.surname != ""
          ? " - "
          : ""
          }}{{ traveller.value.name }}
          {{ traveller.value.surname }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="formContainer" [formGroup]="traveller">
        <div class="row">
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "common.name" | translate }} *</label>
              <input type="text" formControlName="name" matInput required class="form-control form-control--no-border"
                [ngClass]="{ error: traveller.controls['name'].invalid }" />
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "train.user-form.surname" | translate }} *</label>
              <input type="text" formControlName="surname" matInput required
                class="form-control form-control--no-border"
                [ngClass]="{ error: traveller.controls['surname'].invalid }" />
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "train.user-form.surname2" | translate }} </label>
              <input type="text" formControlName="lastSurname" matInput class="form-control form-control--no-border" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "user.form.phone" | translate }} *</label>
              <input type="string" formControlName="phone" matInput required
                class="form-control form-control--no-border" [ngClass]="{
                error: traveller.controls['phone'].invalid
              }" />
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "user.form.birthdate" | translate }} *</label>
              <input type="text" matInput style="display: none" />
              <input id="birthdate" readonly [minDate]="minDateNgStruct" [maxDate]="maxDateNgStruct" name="birthdate"
                ngbDatepicker #dateInput="ngbDatepicker" (click)="dateInput.toggle()" formControlName="birthdate"
                class="form-control form-control--no-border" [ngClass]="{
                error: traveller.controls['birthdate'].invalid
              }" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "user.form.documentType" | translate }} *</label>
              <mat-select formControlName="documentType" required
                class="icon-arrow-rtl form-control form-control--no-border" required [ngClass]="{
                error: traveller.controls['documentType'].invalid
              }">
                <mat-option value="DNI">
                  {{ "user.details.dni" | translate }}
                </mat-option>
                <mat-option value="NIE">
                  {{ "user.form.nie" | translate }}
                </mat-option>
                <mat-option value="PASSPORT">
                  {{ "user.details.passport" | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="none">
              <label>{{ "user.form.number" | translate }} *</label>
              <input type="string" formControlName="documentNumber" matInput required
                class="form-control form-control--no-border" [ngClass]="{
                error: traveller.controls['documentNumber'].invalid
              }" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="summary">
    <div class="fixed-footer">
      <app-trains-summary [activePage]="'passengers'" [stepper]="stepper"></app-trains-summary>
    </div>
  </div>
</div>